import React from 'react';
import { Grid, Ref, Sticky } from 'semantic-ui-react';
import { hasBlocksData } from '@plone/volto/helpers';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import AnchorNavigation from '../AnchorNavigation';
import ReviewStateInfo from '../ReviewStateInfo';
import WikiTitle from '../WikiTitle';
import ContentActions from '../ContentActions';
import AuthorData from '../AuthorData';
import BlocksFilter from '../BlocksFilter';

const WikiView = ({ content }) => {
  const contextRef = React.createRef();
  return (
    <>
      <BlocksFilter />
      {hasBlocksData(content) ? (
        <div id="page-document" className="ui container">
          <Ref innerRef={contextRef}>
            <Grid columns={3}>
              <Grid.Column className={'wiki-anchor'} computer={2} mobile={12}>
                <Sticky context={contextRef} offset={25}>
                  <AnchorNavigation />
                </Sticky>
              </Grid.Column>
              <Grid.Column className={'wiki-content'} computer={8} mobile={12}>
                <ContentActions />
                <ReviewStateInfo content={content} />
                <WikiTitle content={content} />
                <div id="blocks-content">
                  <RenderBlocks content={content} />
                </div>
              </Grid.Column>
              <Grid.Column className={'wiki-author'} computer={2} mobile={12}>
                <Sticky context={contextRef} offset={25}>
                  <AuthorData content={content}></AuthorData>
                </Sticky>
              </Grid.Column>
            </Grid>
          </Ref>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default WikiView;
